import {
  formatMoney,
  formatMoneyFull,
} from "../../../utils/formatters";
import { getExecutiveKpiValues } from "../helpers/decisionNarrativeHelpers";

const getStatusConfiguration = (status) => {
  switch (status) {
    case "OPTIMAL":
      return { label: "Optimizer Recommended", classes: "border-emerald-200 bg-emerald-50/60 text-emerald-700" };
    case "FEASIBLE":
      return { label: "Conditionally Recommended", classes: "border-blue-200 bg-blue-50/60 text-blue-700" };
    default:
      return { label: "Review Required", classes: "border-slate-200 bg-white text-slate-700" };
  }
};

const PortfolioExecutiveConclusion = ({ decision, settings }) => {
  if (!decision) return null;

  const currency = settings?.currency || "";
  const status = getStatusConfiguration(decision?.status);
  const { allocatedCapital, unfundedCapitalAtRiskReduction } = getExecutiveKpiValues(decision);
  const scenarioCount = Array.isArray(decision?.selected_actions)
    ? decision.selected_actions.length
    : 0;

  return (
    <section className={`rounded-2xl border p-6 shadow-sm ${status.classes}`}>
      <div className="flex flex-wrap items-center gap-3">
        <span className="inline-flex rounded-full border border-current/20 bg-white/70 px-3 py-1 text-xs font-semibold">
          {status.label}
        </span>
        <span className="text-xs font-semibold uppercase tracking-[0.16em] text-slate-500">
          Management recommendation
        </span>
      </div>
      <p className="mt-5 text-xs font-semibold uppercase tracking-[0.16em] text-slate-500">
        What does Management recommend for Investment Planning?
      </p>
      <h2 className="mt-2 text-xl font-semibold text-slate-950">Executive Recommendation</h2>
      <p className="mt-3 text-2xl font-semibold leading-9 text-slate-950 lg:text-3xl">
        Take forward a recommended capital commitment of {formatMoneyFull(allocatedCapital, currency)} across {scenarioCount} business scenarios.
      </p>
      <dl className="mt-5 grid gap-4 sm:grid-cols-2">
        <div>
          <dt className="text-xs font-semibold uppercase tracking-wide text-slate-500">Expected financing benefit</dt>
          <dd className="mt-1 text-base font-semibold text-emerald-700">
            {formatMoney(unfundedCapitalAtRiskReduction, currency)} reduction in unfunded Capital at Risk.
          </dd>
        </div>
        <div>
          <dt className="text-xs font-semibold uppercase tracking-wide text-slate-500">Material qualification</dt>
          <dd className="mt-1 text-sm leading-6 text-slate-700">
            Material exposure and scenario appetite gaps remain unresolved for Management planning.
          </dd>
        </div>
      </dl>
    </section>
  );
};

export default PortfolioExecutiveConclusion;
